import React, { useEffect, useState } from "react";
import { listenToCollection, queryCollection } from "../services/database";

const ForumAccessLog = () => {
  const [logsGrouped, setLogsGrouped] = useState({});
  const [dailyUniqueCounts, setDailyUniqueCounts] = useState({
    "2026-04-28": 0,
    "2026-04-29": 0,
  });
  const [forumUsers, setForumUsers] = useState([]);
  const [loggedEmails, setLoggedEmails] = useState(new Set());

  useEffect(() => {
    // Slušaj pristupe
    const unsubscribe = listenToCollection("forum2_access_logs", (data) => {
      const grouped = {};
      const uniquePerDay = {
        "2026-04-28": new Set(),
        "2026-04-29": new Set(),
      };
      const allEmails = new Set();

      data.forEach((entry) => {
        const dateStr = new Date(entry.timestamp).toISOString().split("T")[0];
        if (uniquePerDay[dateStr]) {
          uniquePerDay[dateStr].add(entry.email);
        }
        allEmails.add(entry.email);

        if (!grouped[entry.email]) {
          grouped[entry.email] = [];
        }
        grouped[entry.email].push(entry);
      });

      Object.keys(grouped).forEach((email) => {
        grouped[email].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      });

    setDailyUniqueCounts({
  "2026-04-28": uniquePerDay["2026-04-28"]?.size || 0,
  "2026-04-29": uniquePerDay["2026-04-29"]?.size || 0,
});

      setLoggedEmails(allEmails);
      setLogsGrouped(grouped);
    });

    // Učitaj sve korisnike koji imaju forum: true
    queryCollection("users", "forum", "==", true).then((res) => {
      if (res?.data) {
        setForumUsers(res.data);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div style={styles.wrapper}>
      <h2 style={styles.heading}>Pristupi korisnika (grupisano po e-mailu)</h2>

      {["2026-04-28", "2026-04-29"].map((dateKey) => (
        <div key={dateKey} style={styles.counterBox}>
          📅 <strong>{formatDate(dateKey)}</strong> —{" "}
          <span style={styles.count}>{dailyUniqueCounts[dateKey]}</span>{" "}
          jedinstvenih korisnika pristupilo.
        </div>
      ))}

      {Object.entries(logsGrouped).map(([email, logs]) => (
        <div key={email} style={styles.card}>
          <div style={styles.emailHeader}>{email}</div>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Datum pristupa</th>
                <th style={styles.th}>UID</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => (
                <tr key={index}>
                  <td style={{ ...styles.td, ...styles.timestamp }}>
                    {new Date(log.timestamp).toLocaleString()}
                  </td>
                  <td style={{ ...styles.td, ...styles.uid }}>{log.uid}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      <h3 style={styles.subheading}>📋 Korisnici sa pristupom forumu</h3>
      <ul style={styles.userList}>
        {forumUsers.map((user, i) => {
          const isLogged = loggedEmails.has(user.email);
          return (
            <li
              key={i}
              style={{
                ...styles.userItem,
                backgroundColor: isLogged ? "#e0f6e9" : "#ffecec",
                color: isLogged ? "#2c7a4b" : "#c0392b",
              }}
            >
              {user.email} {isLogged ? "✔️" : "❌"}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const formatDate = (isoDate) => {
  const [year, month, day] = isoDate.split("-");
  return `${day}.${month}.${year}`;
};

const styles = {
  wrapper: {
    maxWidth: "800px",
    margin: "40px auto",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  heading: {
    textAlign: "center",
    fontSize: "24px",
    marginBottom: "30px",
    color: "#2c3e50",
  },
  subheading: {
    fontSize: "20px",
    marginTop: "40px",
    marginBottom: "15px",
    color: "#2c3e50",
    fontWeight: "bold",
  },
  counterBox: {
    marginBottom: "20px",
    fontSize: "18px",
    textAlign: "center",
    padding: "10px 0",
    backgroundColor: "#f1f1f1",
    border: "1px solid #ddd",
    borderRadius: "6px",
  },
  count: {
    fontWeight: "bold",
    color: "#2980b9",
  },
  card: {
    border: "1px solid #ccc",
    borderRadius: "8px",
    marginBottom: "30px",
    overflow: "hidden",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
  emailHeader: {
    backgroundColor: "#f0f0f0",
    padding: "10px 15px",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#333",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    backgroundColor: "#eaeaea",
    padding: "10px",
    border: "1px solid #ccc",
    textAlign: "left",
  },
  td: {
    padding: "10px",
    border: "1px solid #ddd",
    fontSize: "14px",
  },
  timestamp: {
    color: "#2c3e50",
    fontWeight: "500",
  },
  uid: {
    color: "#7f8c8d",
    fontStyle: "italic",
  },
};

export default ForumAccessLog;